import { LabelId } from '@this+that/models';

export type EmailAction = 'spam' | 'inbox' | 'archive' | 'trash';

/**
 * Transforms labelIds based on email action (move to spam, inbox, archive, etc.)
 * Preserves important labels like UNREAD, IMPORTANT, STARRED while modifying location labels
 *
 * @param currentLabelIds - Current label IDs of the email
 * @param action - Action being performed on the email
 * @returns New array of label IDs after the action
 */
export const getLabelIdsForAction = (
  currentLabelIds: LabelId[] | undefined,
  action: EmailAction,
): LabelId[] => {
  const labels = currentLabelIds || [];

  switch (action) {
    case 'spam':
      // Remove INBOX and TRASH, add SPAM
      return [
        ...labels.filter((id) => id !== LabelId.INBOX && id !== LabelId.TRASH),
        LabelId.SPAM,
      ];

    case 'inbox':
      // Remove SPAM and TRASH, add INBOX
      return [
        ...labels.filter((id) => id !== LabelId.SPAM && id !== LabelId.TRASH),
        LabelId.INBOX,
      ];

    case 'archive':
      // Remove INBOX, SPAM, and TRASH (archived emails have no location label)
      return labels.filter(
        (id) =>
          id !== LabelId.INBOX && id !== LabelId.SPAM && id !== LabelId.TRASH,
      );

    case 'trash':
      // Remove INBOX and SPAM, add TRASH
      return [
        ...labels.filter((id) => id !== LabelId.INBOX && id !== LabelId.SPAM),
        LabelId.TRASH,
      ];

    default:
      return labels;
  }
};
